import React from 'react';
import {CenteredTypography, Section} from './CardStyles';
import {styled} from '@mui/material/styles';
import {SIZES, Image, COLORS} from '@fupa/fupa-uikit';
import {motion} from 'framer-motion';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 90%;
`;

const Container = styled(motion.ul)`
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${SIZES['32']};
  list-style: none;
  padding: ${SIZES['32']} 0;
`;

const Clubs = styled('li')`
  display: flex;
  justify-content: center;
  width: 6.25rem;
`;

const OtherUser = styled('a')`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  text-decoration: none;
  cursor: pointer;
`;

const Emblem = styled('div')`
  width: ${SIZES['48']};
  height: ${SIZES['48']};
  margin-bottom: ${SIZES['8']};
`;

const clubs = [
  {
    name: 'FC Blo-Wäiss Medernach',
    image: {
      path: 'https://image.fupa.net/club/HFrhfzeYkIeE/',
      description: null,
      source: null,
      svg: false,
    },
    link: 'https://blowaissmedernach.com/',
    label: 'Webseite des FC Blo-Wäiss Medernach',
  },
  {
    name: '1. CfR Pforzheim',
    image: {
      path: 'https://image.fupa.net/club/pKTQxr8cQwGl/',
      description: null,
      source: null,
      svg: false,
    },
    link: 'https://1cfr.de/',
    label: 'Webseite des 1. CfR Pforzheim',
  },
  {
    name: 'SV Aubing München',
    image: {
      path: 'https://image.fupa.net/club/irJTUNe8HABO/',
      description: null,
      source: null,
      svg: false,
    },
    link: 'https://www.svaubing.de/',
    label: 'Webseite des SV Aubing München',
  },
  {
    name: 'SG Kaarst',
    image: {
      path: 'https://image.fupa.net/club/DCpR0dVtITs3/',
      description: null,
      source: null,
      svg: false,
    },
    link: 'https://www.sgkaarst-fussball.de/',
    label: 'Webseite der SG Kaarst',
  },
];

const ClubCard = () => {
  return (
    <Section backgroundColor={COLORS.white}>
      <Wrapper>
        <CenteredTypography variant='headline2' component='h2'>
          Über 15.000 Vereine vertrauen bereits auf die Widgets von FuPa - und worauf wartest du?
        </CenteredTypography>
        <Container
          whileInView={{opacity: 1, scale: 1, transition: {duration: 1}}}
          initial={{opacity: 0, scale: 0.9}}
          viewport={{amount: 0.8, once: true}}>
          {clubs.map((club) => (
            <Clubs key={club.name}>
              <OtherUser target={'_blank'} href={club.link} aria-label={club.label}>
                <Emblem>
                  <Image alt={`Vereinslogo ${club.name}`} entity='emblem' width={48} height={48} src={club.image} />
                </Emblem>
              </OtherUser>
            </Clubs>
          ))}
        </Container>
      </Wrapper>
    </Section>
  );
};

export default ClubCard;
